import { NgModule } from '@angular/core';

import { TypedTemplateOutletDirective } from './typed-template-outlet.directive';
import { TypedTemplateDirective } from './typed-template.directive';

@NgModule({
  declarations: [TypedTemplateDirective, TypedTemplateOutletDirective],
  exports: [TypedTemplateDirective, TypedTemplateOutletDirective],
})
export class TypedTemplateModule {}
